import React from 'react'
import DeleteForm from './DeleteForm'


function Delete() {



  return (
    <div>
         <div className=' bg-signin-bg'>
    <div className='  grid w-10/12 md:w-8/12   mx-auto h-[100vh] place-items-center'>
   
      <DeleteForm/>
    </div>
    </div>
    </div>
  )
}

export default Delete